import http from 'superagent'

export default class AuthService {

    signUp(user) {

        let model = {
            user: {
                email: user.email,
                password: user.password,
                password_confirmation: user.password_confirmation,
                name: user.name,
            }
        }

        return new Promise((resolve, reject) => {
            http.post('/api/v1/sign-up')
                .send(model)
                .set('Accept', 'application/json')
                .end((error, response) => {
                    if (response.status === 200 || response.status === 201) {
                        const user = JSON.parse(response.text);
                        resolve(user)
                    }
                    else {
                        reject(JSON.parse(response.text))
                    }

                })
        })
    }

    login(email, password) {
        const model = {
            user: {
                email: email,
                password: password
            }
        };

        return new Promise((resolve, reject) => {
            http.post('/api/v1/login')
                .send(model)
                .set('Accept', 'application/json')
                .end((error, response) => {

                    if (response.status === 200 || response.status === 201) {
                        const user = JSON.parse(response.text);
                        resolve(user)
                    }
                    else {
                        reject(JSON.parse(response.text))
                    }

                })
        })
    }

    logout() {
        let authToken = webase.model.auth_token

        return new Promise((resolve, reject) => {
            http.get('/api/v1/logout')
                .set('x-api-token', authToken)
                .end(function (error, response) {
                    if (response.status === 204) {
                        resolve()
                    } else {
                        reject(response.statusText)
                    }
                })
        })
    }

}